import {
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Tooltip,
} from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Menu as ReactAdminMenu, useStore } from 'react-admin';
import { AnimationIcon } from '@app/animation/AnimationIcon';
import { SupplyIcon } from '@app/supply/SupplyIcon';
import { AntennaIcon } from '@app/antenna/AntennaIcon';
import { MemberIcon } from '@app/member/MemberIcon';
import { MissionIcon } from '@app/mission/MissionIcon';
import { TaskIcon } from '@app/tasks/TaskIcon';
import { FormationIcon } from '@app/formation/FormationIcon';
import { ExpensesClaimIcon } from '@app/expenses_claim/ExpensesClaimIcon';
import { HighlightedResourceIcon } from '@app/highlighted_resource/HighlightedResourceIcon';
import { MissionTypeIcon } from '@app/mission_type/MissionTypeIcon';
import { OrganizationIcon } from '@app/organization/OrganizationIcon';
import { StudyFormIcon } from '@app/study_form/StudyFormIcon';
import { CloudSyncIcon } from '@app/cloud_sync/CloudSyncIcon';

const EXTENDED_MENU_STORE_KEY = 'menu.showExtended';

export const Menu = () => {
    const [showExtended, setShowExtended] = useStore(
        EXTENDED_MENU_STORE_KEY,
        false
    );

    const toggleButton = (
        <ListItemButton
            onClick={() => setShowExtended(!showExtended)}
            sx={{ minHeight: 48, px: 2.5 }}
        >
            <Tooltip
                title={showExtended ? 'Show less' : 'Show more'}
                placement="right"
            >
                <ListItemIcon sx={{ minWidth: 0, mr: 2 }}>
                    {showExtended ? (
                        <ExpandLessIcon fontSize="small" />
                    ) : (
                        <ExpandMoreIcon fontSize="small" />
                    )}
                </ListItemIcon>
            </Tooltip>
            <ListItemText
                primary={showExtended ? 'Show less' : 'Show more'}
                primaryTypographyProps={{ variant: 'body2' }}
                sx={{
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                }}
            />
        </ListItemButton>
    );

    return (
        <ReactAdminMenu color="primary">
            <ReactAdminMenu.DashboardItem />
            <ReactAdminMenu.ResourceItem
                leftIcon={<AntennaIcon />}
                name="antenna"
            />
            <ReactAdminMenu.ResourceItem
                leftIcon={<MemberIcon />}
                name="member"
            />
            <ReactAdminMenu.ResourceItem
                leftIcon={<MissionIcon />}
                name="mission"
            />
            <ReactAdminMenu.ResourceItem
                leftIcon={<AnimationIcon />}
                name="animation"
            />
            <ReactAdminMenu.ResourceItem
                leftIcon={<SupplyIcon />}
                name="supply"
            />
            <ReactAdminMenu.ResourceItem leftIcon={<TaskIcon />} name="task" />

            {toggleButton}

            {showExtended && (
                <>
                    <ReactAdminMenu.ResourceItem
                        leftIcon={<FormationIcon />}
                        name="formation"
                    />
                    <ReactAdminMenu.ResourceItem
                        leftIcon={<ExpensesClaimIcon />}
                        name="expensesClaim"
                    />
                    <ReactAdminMenu.ResourceItem
                        leftIcon={<HighlightedResourceIcon />}
                        name="highlightedResource"
                    />

                    <ReactAdminMenu.Item
                        to="/cloud-sync"
                        primaryText="Cloud sync"
                        leftIcon={<CloudSyncIcon />}
                    />

                    <ReactAdminMenu.ResourceItem
                        leftIcon={<MissionTypeIcon />}
                        name="missionType"
                    />
                    <ReactAdminMenu.ResourceItem
                        leftIcon={<StudyFormIcon />}
                        name="studyForm"
                    />
                    <ReactAdminMenu.ResourceItem
                        leftIcon={<OrganizationIcon />}
                        name="organization"
                    />
                </>
            )}
        </ReactAdminMenu>
    );
};
